/**
 * Created by apokdev on 6/6/17.
 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import ListaServicios from './ListaServicios';

export default class extends Component {
    render() {
        let data = this.props.poi;

        let info_ruta = undefined;
        if (data.ruta && this.props.showRuta) {
            info_ruta = (
                <p key={"info_ruta"}>
                    <b>Ruta:</b> <a href={`/ruta/${data.ruta.slug}`}>{data.ruta.nombre}</a>
                </p>
            );
        } else {
            info_ruta = "";
        }

        let info_sector = undefined;
        if (data.sector && this.props.showSector) {
            info_sector = (
                <p key={"info_sector"}>
                    <b>Localidad:</b> {data.sector.nombre}
                </p>
            );
        } else {
            info_sector = "";
        }

        let info_estado = undefined;
        let estado = undefined;
        if (data.ruta) {
            estado = data.ruta.estado;
        } else if (data.sector) {
            estado = data.sector.estado;
        }
        if (estado && this.props.showEstado) {
            info_estado = (
                <p key={"info_estado"}>
                    <b>Estado:</b> <Link to={`/estado/${estado}`}>{estado}</Link>
                </p>
            );
        } else {
            info_estado = "";
        }

        if (data) {
            let imagen = '/img/brujula_oficial_gris.png';

            let codigoFavDest = [];
            if (data.destacado) {
                codigoFavDest.push(
                    <i key="dest" className="destacado-icon glyphicon glyphicon-bookmark" title="Destacado"/>
                )
            }
            if (data.favorito) {
                codigoFavDest.push(
                    <i key="fav" className="favorito-icon glyphicon glyphicon-heart" title="Favorito de Valentina"/>
                );
            }

            if (data.favorito || data.destacado) {
                codigoFavDest = (
                    <div className="favorito-destacado">
                        {codigoFavDest}
                    </div>
                );
            }

            if (data.imagenes.length !== 0) {
                imagen = data.imagenes[0].thumbnail;
            }

            return (
                <div data-to={`poi/${data.slug}`}>
                    <div className="poi-info media">
                        <div className="media-left">
                            <div className="thumbnail">
                                <Link to={`/poi/${data.slug}`}>
                                    <img src={imagen} alt={data.nombre}/>
                                </Link>
                            </div>
                            <div className="visible-xs">
                                {/*<PoiRating rating={data.valoracion}/>*/}
                                {codigoFavDest}
                            </div>
                        </div>
                        <div className="media-body">
                            <h4 className="media-heading">
                                <Link to={`/poi/${data.slug}`}>
                                    {data.nombre}
                                </Link>
                            </h4>
                            {
                                (function () {
                                    let info = [];
                                    if (data.tipo.nombre) {
                                        info.push(
                                            <p key={"info-tipo"}><b>{data.tipo.nombre}</b></p>
                                        )
                                    }
                                    if (data.telefono) {
                                        info.push(
                                            <p key={"info-telf"}><b>Tlf: </b> {data.telefono}</p>
                                        )
                                    }
                                    if (data.email) {
                                        info.push(
                                            <p key={"info-correo"}><b>Correo: </b>
                                                <a href={`mailto:${data.email}`}>{data.email}</a>
                                            </p>
                                        );
                                    }
                                    info.push(info_estado);
                                    info.push(info_ruta);
                                    info.push(info_sector);
                                    if (data.servicios.length) {
                                        info.push(
                                            <div key={"info-servicios"} className="hidden-xs">
                                                <ListaServicios servicios={data.servicios} max="9"/>
                                            </div>
                                        );
                                    }
                                    return info;
                                })()
                            }
                            <div className="hidden-xs">
                                {/*<PoiRating rating={data.valoracion}/>*/}
                                {codigoFavDest}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Poi.js